export class Base {

    public valid = true;

}